<template>
  <div>
    <template v-if="isAccountUser">
      <user-avatar-form :user-id="formData.id"></user-avatar-form>

      <form-field-full-name
        :entity="form"
        :validation-errors="validationErrors"
      ></form-field-full-name>

      <form-field-timezones
        :entity="form"
        :validation-errors="validationErrors"
      ></form-field-timezones>

      <div v-if="canUpdateMobileNumber" class="mb-100">
        <form-field-phone
          label="Mobile Number"
          v-model="form.notifications_phone_number"
          :validation-errors="validationErrors.notifications_phone_number"
          require-prefix
        ></form-field-phone>

        <p class="mobile_warning">
          <strong>NOTE</strong> In order to get text notifications you must include your country code at the front of
          your
          number (e.g. 1-210-867-5309). We only support texting to United States and Canada for text Notification.
        </p>

        <button-link
          :loading="sending"
          @click="sendTestNotification"
        >Send Test Notification
        </button-link>
      </div>
    </template>

    <template
      v-if="$route.query.modal === 'users'"
    >
      <template v-if="isAccountUser">
        <form-field-select
          label="Is Owner"
          v-model="form.is_owner"
          :validation-errors="validationErrors.is_owner"
        >
          <option :value="1">Yes</option>
          <option :value="0">No</option>
        </form-field-select>
      </template>
      <h2 v-else class="third_party_permission_header">Manage Partner Permissions</h2>

      <template v-if="!form.is_owner">
        <p class="mt-100 mb-75">Roles</p>

        <form-field-checkbox
          label="Lead Manager"
          v-model="form.is_lead_manager"
          :validation-errors="validationErrors.is_lead_manager"
          require-prefix
        />

        <form-field-checkbox
          label="Acquisitions Manager"
          v-model="form.is_acquisitions_manager"
          :validation-errors="validationErrors.is_acquisitions_manager"
          require-prefix
        />

        <form-field-checkbox
          label="Dispositions Manager"
          v-model="form.is_dispositions_manager"
          :validation-errors="validationErrors.is_dispositions_manager"
          require-prefix
        />

        <form-field-checkbox
          label="Rehab Manager"
          v-model="form.is_rehab_manager"
          :validation-errors="validationErrors.is_rehab_manager"
          require-prefix
        />

        <form-field-checkbox
          label="Transaction Coordinator"
          v-model="form.is_transaction_coordinator"
          :validation-errors="validationErrors.is_transaction_coordinator"
          require-prefix
        />
      </template>



      <form-field-select
        v-if="$store.getters.account.has_sensitive_data_ability && isAccountUser"
        label="Hide Sensitive Data"
        v-model="form.hide_sensitive_data"
        :validation-errors="validationErrors.hide_sensitive_data"
      >
        <option :value="true">Yes</option>
        <option :value="false">No</option>
      </form-field-select>
    </template>
  </div>
</template>

<script>
import UserAvatarForm from "./UserAvatarForm";
import {FormMixin} from "./forms.mixin";
import api from "../api";
import {ENUMS} from "../services/enums";

export default {
  name: "UserForm",
  props: ["formData"],
  mixins: [FormMixin],
  components: {
    UserAvatarForm
  },
  data() {
    return {
      validationErrors: {},
      form: {},
      defaultForm: {
        first_name: "",
        last_name: "",
        timezone: "America/Chicago",
        notifications_phone_number: "",
        is_owner: 0,
        hide_sensitive_data: 0,
        // can_access_all_leads: this.formData.can_access_all_leads,
        // can_delete_leads: this.formData.can_delete_leads,
        // can_export_leads: this.formData.can_export_leads,
        // can_access_all_task: this.formData.can_access_all_task,
        // can_access_all_appointments: this.formData.can_access_all_appointments,
        // can_access_settings: this.formData.can_access_settings,
        // can_access_financial_stats: this.formData.can_access_financial_stats,
        // can_edit_financials: this.formData.can_edit_financials,
        // can_manage_account: this.formData.can_manage_account,
        // can_manage_users: this.formData.can_manage_users,
        // can_access_comm_log_page: this.formData.can_access_comm_log_page,
        // can_export_contacts: this.formData.can_export_contacts,
        is_lead_manager: this.formData.is_lead_manager,
        is_acquisitions_manager: this.formData.is_acquisitions_manager,
        is_dispositions_manager: this.formData.is_dispositions_manager,
        is_rehab_manager: this.formData.is_rehab_manager,
        is_transaction_coordinator: this.formData.is_transaction_coordinator,
      },
      phoneNumberIsChanged: false,
      sending: false,
    };
  },
  watch: {
    "form.notifications_phone_number"(newVal, oldVal) {
      if (oldVal !== undefined
        && this.formData.notifications_phone_number !== newVal
      ) {
        this.phoneNumberIsChanged = true;
      }
    }
  },
  created() {
    this.form = (this.formData) ? this.$utils.clone(this.formData) : this.$utils.clone(this.defaultForm);
  },
  computed: {
    isAccountUser() {
      return this.form.type === ENUMS.UserTypeEnum.Account.value;
    },
    canUpdateMobileNumber() {
      return this.$store.getters.authUser.is_owner || this.$store.state.activeUser.id === this.formData.id;
    },
    hasTextNotificationFeature() {
      return this.$store.getters.account.has_text_notifications_feature;
    }
  },
  methods: {
    update() {
      return this.updateNotificationPhoneNumber()
        .then((res) => {
          return api.users.update(this.form)
            .then((res) => {
              this.$buefy.toast.open({
                message: "User was updated",
                type: "is-success"
              });

              return res;
            });
        });
    },
    updateNotificationPhoneNumber() {
      return new Promise((resolve, reject) => {
        // allow only auth user to update their own phone number
        if (this.canUpdateMobileNumber && this.phoneNumberIsChanged) {
          this.$api.users.updateNotificationPhoneNumber(this.form)
            .then((res) => {
              this.phoneNumberIsChanged = false;
              resolve(res);
            })
            .catch((error) => {
              reject(error);
            });

          return;
        }

        resolve();
      });
    },
    sendTestNotification() {
      this.sending = true;
      this.$api.users.testNotificationNumber(this.form)
        .then(() => {
          this.$buefy.toast.open({
            message: "A text has been sent to your number",
            type: "is-success"
          });
        }).finally(() => {
        this.sending = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.third_party_permission_header {
  margin-bottom: 1rem;
  font-weight: bold;
  font-size: 1.25rem;
}

.mobile_warning {
  margin-bottom: 4px;
  font-size: 0.875rem;
  line-height: 1.3;
}
</style>
